import { Link } from "@tanstack/react-router";
import { SubizaLogo } from "./subiza-logo";
import { Facebook, X, Instagram, Linkedin, Mail } from "lucide-react";
import { SUPPORT_EMAIL } from "@/lib/subiza";

// Social URLs config - placeholders to be filled
const socialUrls = {
  facebook: "#",
  x: "#",
  instagram: "#",
  linkedin: "#",
};

const footerLinkClass =
  "hover:text-accent transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-sm";

const footerLinks = [
  { to: "/", label: "Homepage" },
  { to: "/founders", label: "About Us" },
  { to: "/terms", label: "Terms and Conditions" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/acceptable-use", label: "Acceptable Use Policy" },
  { to: "/auth", label: "Contact Us" },
];

export function Footer() {
  return (
    <footer className="bg-bg px-4 pt-16">
      {/* Outer frame: slightly lighter than page background, rounded, border, padded */}
      <div className="bg-surface rounded-2xl md:rounded-3xl border border-border/20 p-4 md:p-6 mx-auto max-w-7xl">
        {/* Inner container: very dark surface, rounded, padding */}
        <div className="bg-bg rounded-3xl p-6 md:p-8">
          <div className="space-y-6 md:space-y-8 text-center">
            {/* Row 1: Logo */}
            <SubizaLogo showTagline={true} className="mx-auto" />

            {/* Row 2: Navigation links */}
            <nav
              aria-label="Footer"
              className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm md:text-base font-medium text-muted"
            >
              {footerLinks.map((link) => (
                <Link key={link.to} to={link.to} className={footerLinkClass}>
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Row 3: Support / contact */}
            <p className="flex flex-wrap items-center justify-center gap-2 text-sm text-muted">
              <Mail className="size-4 text-accent" aria-hidden="true" />
              Need help? Email support at{" "}
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="font-medium text-accent underline underline-offset-2 transition-colors hover:text-accent/80"
              >
                {SUPPORT_EMAIL}
              </a>
            </p>

            {/* Row 4: Social icons */}
            <div className="flex justify-center gap-4 md:gap-6">
              <a
                href={socialUrls.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-muted hover:text-text transition-colors duration-200 flex items-center justify-center"
              >
                <Facebook className="h-5 w-5 md:h-6 md:w-6" />
              </a>
              <a
                href={socialUrls.x}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X"
                className="text-muted hover:text-text transition-colors duration-200 flex items-center justify-center"
              >
                <X className="h-5 w-5 md:h-6 md:w-6" />
              </a>
              <a
                href={socialUrls.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-muted hover:text-text transition-colors duration-200 flex items-center justify-center"
              >
                <Instagram className="h-5 w-5 md:h-6 md:w-6" />
              </a>
              <a
                href={socialUrls.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-muted hover:text-text transition-colors duration-200 flex items-center justify-center"
              >
                <Linkedin className="h-5 w-5 md:h-6 md:w-6" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
